import { render, staticRenderFns } from "./ListOT.vue?vue&type=template&id=2d2e82a2&scoped=true&lang=pug"
import script from "./ListOT.vue?vue&type=script&lang=js"
export * from "./ListOT.vue?vue&type=script&lang=js"
import style0 from "./ListOT.vue?vue&type=style&index=0&id=2d2e82a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2e82a2",
  null
  
)

export default component.exports